import React from 'react'
import { MapContainer, TileLayer } from 'react-leaflet';

import { useSelector } from 'react-redux';
import { liveTrackinglayoutSelector } from '../../../features/layout/layoutSlice';

import {
    zoomSelector,
    centerSelector,
    mapControlSelector,
    gensetViewportClipSelector,
} from '../../../features/map/mapSlice';

import OsmChildren from './OsmChildren';
import OsmMapControl from './OsmMapControl';

const OpenstreetmapInstance = () => {
    const dimentions = useSelector(liveTrackinglayoutSelector);
    const zoom = useSelector(zoomSelector);
    const center = useSelector(centerSelector);
    const mapControl = useSelector(mapControlSelector);
    const gensetViewportClip = useSelector(gensetViewportClipSelector);

    const useGensetClip = Boolean(gensetViewportClip)
        && (mapControl === 'genset' || mapControl === 'track');
    const clipInset = gensetViewportClip
        ? `inset(${gensetViewportClip.top}px ${gensetViewportClip.right}px ${gensetViewportClip.bottom}px ${gensetViewportClip.left}px round ${gensetViewportClip.radius || 0}px)`
        : undefined;
    const mapStyle = {
        ...dimentions.osm,
        ...(useGensetClip
            ? {
                clipPath: clipInset,
                WebkitClipPath: clipInset,
                zIndex: 20,
                pointerEvents: 'auto',
            }
            : {}),
    };

    return (
        <MapContainer
            center={center}
            zoom={zoom}
            scrollWheelZoom={true}
            id="mapid"
            style={mapStyle}
        >
            <TileLayer
                attribution='Roadmatics <a href="http://osm.org/copyright">OpenStreetMap</a>'
                url="https://osm.roadr.in/osm_tiles/{z}/{x}/{y}.png"
            />
            <OsmChildren />
            <OsmMapControl />
        </MapContainer>
    );
}

export default OpenstreetmapInstance;
